import { render } from "./ListarPessoas.vue?vue&type=template&id=61daaa24&scoped=true"
import script from "./ListarPessoas.vue?vue&type=script&lang=js"
export * from "./ListarPessoas.vue?vue&type=script&lang=js"

import "./ListarPessoas.vue?vue&type=style&index=0&id=61daaa24&scoped=true&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61daaa24"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QPagination from 'quasar/src/components/pagination/QPagination.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon,QTable,QInput,QTd,QPagination});
